import Aos from "aos";
import React, { useEffect } from "react";
import Slider from "react-slick";

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next" onClick={onClick}>
      <img src="/assets/services/next.svg" alt="" />
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev" onClick={onClick}>
      <img src="/assets/services/prev.svg" alt="" />
    </div>
  );
};

function LmsSlider({ data }) {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);
  const settings = {
    slidesToShow: 2.5,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <>
      <Slider {...settings}>
        {data && data.length>0 &&data?.map((item, index) => (
          <div key={item._id || index}>
            <div
              data-aos="fade-up"
              className="md:h-[131px] h-[120px] md:w-[262px] w-[236px] border-[3px] border-[#6953A3] bg-[#FDD60D] rounded-b-full flex justify-center items-center"
            >
              <h6 className="text-center max-w-[143px] w-full mx-auto font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]">
                {item.title}
              </h6>
            </div>
          </div>
        ))}
        {/* <div>
                    <div data-aos="fade-up" className='md:h-[131px] h-[120px] md:w-[262px] w-[236px] border-[3px] border-[#6953A3] bg-[#FDD60D] rounded-b-full flex justify-center items-center'>
                    <h6 className='text-center max-w-[143px] w-full mx-auto font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Onboarding Training</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='md:h-[131px] h-[120px] md:w-[262px] w-[236px] border-[3px] border-[#6953A3] bg-[#FDD60D] rounded-b-full flex justify-center items-center'>
                    <h6 className='text-center max-w-[143px] w-full mx-auto font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Soft Skills Modules</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up"  className='md:h-[131px] h-[120px] md:w-[262px] w-[236px] border-[3px] border-[#6953A3] bg-[#FDD60D] rounded-b-full flex justify-center items-center'>
                    <h6 className='text-center max-w-[143px] w-full mx-auto font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Compliance Training</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='md:h-[131px] h-[120px] md:w-[262px] w-[236px] border-[3px] border-[#6953A3] bg-[#FDD60D] rounded-b-full flex justify-center items-center'>
                    <h6 className='text-center max-w-[143px] w-full mx-auto font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Performance Tracking</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='md:h-[131px] h-[120px] md:w-[262px] w-[236px] border-[3px] border-[#6953A3] bg-[#FDD60D] rounded-b-full flex justify-center items-center'>
                    <h6 className='text-center max-w-[143px] w-full mx-auto font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Certification System</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='md:h-[131px] h-[120px] md:w-[262px] w-[236px] border-[3px] border-[#6953A3] bg-[#FDD60D] rounded-b-full flex justify-center items-center'>
                    <h6 className='text-center max-w-[143px] w-full mx-auto font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Daily Practice Questions</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='md:h-[131px] h-[120px] md:w-[262px] w-[236px] border-[3px] border-[#6953A3] bg-[#FDD60D] rounded-b-full flex justify-center items-center'>
                    <h6 className='text-center max-w-[143px] w-full mx-auto font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Leaderboards</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='md:h-[131px] h-[120px] md:w-[262px] w-[236px] border-[3px] border-[#6953A3] bg-[#FDD60D] rounded-b-full flex justify-center items-center'>
                    <h6 className='text-center max-w-[143px] w-full mx-auto font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Mock Tests</h6>
                    </div>
                </div> */}
      </Slider>
    </>
  );
}

export default LmsSlider;
